var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ExpedienteService } from '../../services/expediente.service';
import { Pager } from '../../common/pager/pager.component';
import { CommonService } from '../../services/common.service';
var RepresentanteQrPopupComponent = (function () {
    function RepresentanteQrPopupComponent(_service, _comService, sanitizer) {
        this._service = _service;
        this._comService = _comService;
        this.sanitizer = sanitizer;
        this.visible = false;
        this.visiblePreview = false;
        this.isComprobante = false;
        this.images = [];
        this.pageSize = 5;
        this.pageNumber = 0;
        this.showWarn = false;
    }
    RepresentanteQrPopupComponent.prototype.loadRepresentanteQr = function (id, perId, proId, vinId) {
        var _this = this;
        this.aviso = this._comService.getConfiguracion("AVISOACT");
        this.id = id;
        this.images = [];
        this._service.findRepresentanteQr(this.id, perId, proId, vinId, 0, 5).subscribe(function (response) {
            _this.parte = response;
            _this.showWarn = _this.parte.isJpx;
            var i = 0;
            var that = _this;
            _this.pageNumber = _this.parte.pages;
            _this.visiblePreview = true;
            _this.titulo = "COMPROBANTE - " + _this.parte.numero + "/" + _this.parte.anio + " | " + _this.parte.repNomyApe;
            response.comprobante.split(",").forEach(function (image) {
                that.images[i++] = _this.sanitizer.bypassSecurityTrustResourceUrl("data:image/png;base64,"
                    + image);
            });
            _this.visible = true;
            _this.scrollable.nativeElement.scrollTop = 0;
        }, function (error) {
            //console.log("Error al generar el comprobante");
            _this.visible = false;
            _this.visiblePreview = false;
        });
    };
    RepresentanteQrPopupComponent.prototype.downloadData = function () {
        var _this = this;
        this._comService.emitBlocking(true);
        this._service.getPdfComprobanteRepresentante(this.id, this.parte.uuidParId).subscribe(function (response) {
            //console.log("blob: " + response.size);
            saveAs(response, "comprobante.pdf");
            _this._comService.emitBlocking(false);
        }, function (error) {
            _this._comService.emitBlocking(false);
        });
    };
    RepresentanteQrPopupComponent.prototype.finalize = function () {
        this.visible = false;
        this.visiblePreview = false;
        this.parte = null;
        this.firma = null;
        this.images = [];
        this.visiblePreview = false;
        if (this.pager) {
            this.pager.pcount = 0;
        }
    };
    return RepresentanteQrPopupComponent;
}());
__decorate([
    Input(),
    __metadata("design:type", Number)
], RepresentanteQrPopupComponent.prototype, "id", void 0);
__decorate([
    ViewChild('scrollable'),
    __metadata("design:type", ElementRef)
], RepresentanteQrPopupComponent.prototype, "scrollable", void 0);
__decorate([
    ViewChild(Pager),
    __metadata("design:type", Pager)
], RepresentanteQrPopupComponent.prototype, "pager", void 0);
RepresentanteQrPopupComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'representante-qr-popup',
        templateUrl: 'representante-qr-popup.component.html'
    }),
    __metadata("design:paramtypes", [ExpedienteService, CommonService, DomSanitizer])
], RepresentanteQrPopupComponent);
export { RepresentanteQrPopupComponent };
//# sourceMappingURL=representante-qr-popup.component.js.map